import { AuditResult } from '@scale/shared/defaults';
import { Dialog, DialogTitle, DialogContent } from 'design-system';
import Kbd from 'design-system/Kbd';
import _ from 'lodash';
import { resultShortcuts, resultColors } from '../types';
import { makeStyles } from 'design-system/product/theme';

function TextBasedSpeedAuditShortcutModal({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}) {
  const classes = useStyles();
  const isMac =
    typeof navigator !== 'undefined' && navigator.platform.toLowerCase().indexOf('mac') !== -1;

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} maxWidth="md" fullWidth>
      <DialogTitle>Keyboard Shortcuts</DialogTitle>
      <DialogContent>
        <div className={classes.shortcut}>
          {isMac ? <Kbd>command</Kbd> : <Kbd>ctrl</Kbd>} + <Kbd>z</Kbd>
          <span className={classes.shortcutText}>Undo</span>
        </div>
        <div className={classes.shortcut}>
          <Kbd>shift</Kbd> + {isMac ? <Kbd>command</Kbd> : <Kbd>ctrl</Kbd>} + <Kbd>z</Kbd>
          <span className={classes.shortcutText}>Redo</span>
        </div>
        <div className={classes.shortcut}>
          {isMac ? <Kbd>command</Kbd> : <Kbd>ctrl</Kbd>} + <Kbd>f</Kbd>
          <span className={classes.shortcutText}>Launch find and replace</span>
        </div>
        The following shortcuts only work when a rating cell is in focus (it will have a blue
        outline).
        <br />
        {_.values(AuditResult).map(score => (
          <div key={score} className={classes.shortcut}>
            <Kbd>{resultShortcuts[score]}</Kbd>
            <span className={classes.shortcutText}>
              Assign grade "{score}" for{' '}
              <span style={{ background: resultColors[score], fontWeight: 500 }}>{score}</span>.
            </span>
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
}

const useStyles = makeStyles({
  shortcut: {
    marginBottom: '16px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  shortcutText: {
    marginLeft: '12px',
    fontSize: '14px',
    lineHeight: '24px',
  },
});

export default TextBasedSpeedAuditShortcutModal;
